import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadPracticeRequests = () => {
    return {
        type: actionTypes.LOAD_PRACTICE_REQUESTS
    }
}

export const setPracticeRequests = (practiceRequests) => {
    return {
        type: actionTypes.SET_PRACTICE_REQUESTS,
        practiceRequests: practiceRequests
    }
}

export const getPracticeRequests = () => {
    return (dispatch) => {
        dispatch(loadPracticeRequests())
        axios.get(`/api/v1/practice`)
            .then( response => {
                dispatch(setPracticeRequests(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const loadEnterprises = () => {
    return {
        type: actionTypes.LOAD_PRACTICE_ENTERPRISES
    }
}

export const setEnterprises = (enterprises) => {
    return {
        type: actionTypes.SET_PRACTICE_ENTERPRISES,
        enterprises: enterprises
    }
}

export const getEnterprises = () => {
    return (dispatch) => {
        dispatch(loadEnterprises())
        axios.get(`/api/v1/enterprises`)
            .then( response => {
                dispatch(setEnterprises(response.data))
            } )
            .catch( error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

////////////////////////////////////////////////////////////////

export const sendPracticeRequest = () => {
    return {
        type: actionTypes.SEND_PRACTICE_REQUEST
    }
}

export const receiveDiplomaRequestResultOnSuccess = (result) => {
    return {
        type: actionTypes.RECEIVE_PRACTICE_REQUEST_RESULT_ON_SUCCESS,
        newPracticeRequest: result
    }
}

export const receivePracticeRequestResultOnError = () => {
    return {
        type: actionTypes.RECEIVE_PRACTICE_REQUEST_RESULT_ON_ERROR
    }
}

export const postPracticeRequest = (dto) => {
    return (dispatch) => {
        dispatch(sendPracticeRequest())
        axios.post(`/api/v1/practice/create`, dto)
            .then( response => {
                dispatch(setMessage({type: 'success', text: "Заявка успешно отправлена."}))
                dispatch(receiveDiplomaRequestResultOnSuccess(response.data));
            } )
            .catch( error => {
                dispatch(receivePracticeRequestResultOnError());
                dispatch(setMessage({type: 'error', text: "Произошла ошибка при отправке заявки."}))
            } );
    }
}


////////////////////////////////////////////////////////////////

export const modifyPracticeRequest = () => {
    return {
        type: actionTypes.UPDATE_PRACTICE_REQUEST
    }
}

export const receiveUpdatedPracticeRequestOnSuccess = (result) => {
    return {
        type: actionTypes.RECEIVE_UPDATED_PRACTICE_REQUEST_ON_SUCCESS,
        practiceRequest: result
    }
}

export const receiveUpdatedPracticeRequestOnError = () => {
    return {
        type: actionTypes.RECEIVE_UPDATED_PRACTICE_REQUEST_ON_ERROR
    }
}

export const updatePracticeRequest = (dto) => {
    return (dispatch) => {
        dispatch(modifyPracticeRequest())
        axios.post(`/api/v1/practice/update`, dto)
            .then( response => {
                dispatch(receiveUpdatedPracticeRequestOnSuccess(response.data));
            } )
            .catch( error => {
                dispatch(receiveUpdatedPracticeRequestOnError());
                dispatch(setMessage({type: "warning", text: "Произошла ошибка при изменении заявки."}))
            } );
    }
}